import API from "./APIService"
import BaseService from "./BaseService"

class DashboardService extends BaseService {
	component = null

	constructor(component = null) {
		super()
		this.component = component
	}

	baseServicePath = () => {
		return API.url("dashboard")
	}
}

export default DashboardService
